/*
  Syncs the "We buy request" checkbox to a cart attribute and ensures
  it is persisted before proceeding to checkout from either the cart page
  or the cart drawer.
*/

(() => {
  const CHECKBOX_SELECTOR = '#cart-we-buy-checkbox';
  const CART_FORM_SELECTOR = '#cart';
  const DRAWER_FORM_SELECTOR = '#CartDrawer-Form';
  const CART_CHECKOUT_BUTTON_SELECTOR = '#checkout';
  const DRAWER_CHECKOUT_BUTTON_SELECTOR = '#CartDrawer-Checkout';
  const ATTRIBUTE_KEY = 'we_buy_request';

  const getCheckbox = () => document.querySelector(CHECKBOX_SELECTOR);

  const createHiddenCheckoutInput = (form) => {
    if (!form) return;
    const existing = form.querySelector('input[name="checkout"]');
    if (existing) return existing;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'checkout';
    form.appendChild(input);
    return input;
  };

  const createWeBuyMetafieldInput = (form, isRequested) => {
    if (!form) return;
    // Remove existing input if present
    const existing = form.querySelector('input[name="attributes[we_buy_request]"]');
    if (existing) existing.remove();

    // Create new hidden input for the cart attribute
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'attributes[we_buy_request]';
    input.value = isRequested ? 'true' : 'false';
    form.appendChild(input);
    return input;
  };

  const updateCartWeBuyAttribute = async (isRequested) => {
    try {
      const body = {
        attributes: {
          [ATTRIBUTE_KEY]: isRequested ? 'true' : 'false',
        },
      };
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(body),
        credentials: 'same-origin',
      });
      if (!response.ok) throw new Error('Cart update failed');
      return true;
    } catch (error) {
      return false;
    }
  };

  const prefillFromCart = async () => {
    const checkbox = getCheckbox();
    if (!checkbox) return;
    try {
      const response = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin',
      });
      if (!response.ok) return;
      const cart = await response.json();
      const value = cart?.attributes?.[ATTRIBUTE_KEY];
      checkbox.checked = value === 'true';
    } catch (e) {
      // Ignore prefill errors
    }
  };

  const handleCheckboxChange = async () => {
    const checkbox = getCheckbox();
    if (!checkbox) return;
    await updateCartWeBuyAttribute(checkbox.checked);
  };

  const proceedToCheckout = (form, isRequested) => {
    if (!form) {
      window.location.href = '/checkout';
      return;
    }
    createHiddenCheckoutInput(form);
    createWeBuyMetafieldInput(form, isRequested);
    try {
      form.submit();
    } catch (_e) {
      window.location.href = '/checkout';
    }
  };

  const handleCheckoutClick = async (event, formSelector) => {
    const target = event.target;
    const button = target?.closest(CART_CHECKOUT_BUTTON_SELECTOR + ', ' + DRAWER_CHECKOUT_BUTTON_SELECTOR);
    if (!button) return;

    const checkbox = getCheckbox();
    const form = document.querySelector(formSelector);
    const isRequested = Boolean(checkbox?.checked);

    button.disabled = true;
    try {
      await updateCartWeBuyAttribute(isRequested);
    } finally {
      proceedToCheckout(form, isRequested);
      setTimeout(() => {
        button.disabled = false;
      }, 1500);
    }
  };

  const init = () => {
    prefillFromCart();

    document.addEventListener('change', (event) => {
      if (event.target && event.target.matches(CHECKBOX_SELECTOR)) {
        handleCheckboxChange();
      }
    });

    document.addEventListener('click', (event) => {
      // Cart page checkout
      if (event.target && event.target.closest(CART_CHECKOUT_BUTTON_SELECTOR)) {
        event.preventDefault();
        handleCheckoutClick(event, CART_FORM_SELECTOR);
        return;
      }
      // Cart drawer checkout
      if (event.target && event.target.closest(DRAWER_CHECKOUT_BUTTON_SELECTOR)) {
        event.preventDefault();
        handleCheckoutClick(event, DRAWER_FORM_SELECTOR);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


